export default class AccessTokenResponseModel {
  accessToken = ''

  accessTokenExpires = 0
}
